var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setup-container" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-col",
            { staticClass: "content", attrs: { xs: 24, sm: 12 } },
            [
              _c("p", { staticClass: "step-text" }, [_vm._v("STEP 2 OF 3")]),
              _vm._v(" "),
              _c("h2", [
                _vm._v("Create a password to start your UNIFI membership")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v("Just a few more steps and you’re finished!")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "userForm",
                  attrs: { model: _vm.userForm, rules: _vm.userFromRules }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.isUserCreated,
                          placeholder: "Email"
                        },
                        model: {
                          value: _vm.userForm.email,
                          callback: function($$v) {
                            _vm.$set(_vm.userForm, "email", $$v)
                          },
                          expression: "userForm.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Create a password",
                          "show-password": ""
                        },
                        model: {
                          value: _vm.userForm.password,
                          callback: function($$v) {
                            _vm.$set(_vm.userForm, "password", $$v)
                          },
                          expression: "userForm.password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "next-button",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.isUserCreated
                                ? _vm.goToMoreDetailsStep("userForm")
                                : _vm.checkUserAndCreate("userForm")
                            }
                          }
                        },
                        [_vm._v("Next")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.alertDialogVisible
        ? _c("u-connect-check-user-dialog", {
            attrs: {
              alertDialogVisible: _vm.alertDialogVisible,
              dialogBoxTitle: _vm.dialogBoxTitle,
              dialogBoxMessage: _vm.dialogBoxMessage,
              userTypeErrorCode: _vm.userTypeErrorCode
            },
            on: { onClose: _vm.handleCloseRegisterDialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf4b8bbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf4b8bbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectSetPasswordStep.vue
// module id = null
// module chunks = 